import styles from './Footer.module.css';
import { useLanguageHook, useRetailerHook } from '../../Hooks/use-context-hooks';
import { getStepUpChartLinks, getTransitionsChartLinks } from '../../config/use-resources-config';
import { useLinkConfig } from '../../config/use-links-config';
import NavigationLinks from '../../Shared/Components/UI/NavigationElements/NavigationLinks.jsx';
import { ExternalNavigationLinks } from '../../Shared/Components/UI/NavigationElements/ExternalNavigationLinks.jsx';
import BodyContainer from '../../Shared/Components/UI/BodyContainer/BodyContainer';
import LanguageSelectionMenu from '../../Shared/Components/UI/LanguageSelectionMenu/LanguageSelectionMenu';
import LinkedLogo from '../../components/Logo/LinkedLogo.jsx';
import { GridSystem } from '../../Shared/Components/GridSystem/GridSystem.jsx';
import { PageText } from '../../components/Text/Text.jsx';
import { LinkComponent } from '../../components/Links/LinkComponent.jsx';

const Footer = () => {
    const { translatedText, language } = useLanguageHook();
    const { isHomeDepotApp } = useRetailerHook();
    const {
        navCategoryLinks,
        allCategoryLink,
        resourceLinks,
        exclusiveLinks,
        nativeEmailLinks,
        legalLinks,
    } = useLinkConfig();

    // console.log(resourceLinks)
    // Dynamic PDF/retailer links (language/retailer aware)
    const stepUpLinks = getStepUpChartLinks(language, isHomeDepotApp.isHomeDepotActive, translatedText);
    const transitionsLinks = getTransitionsChartLinks(language, isHomeDepotApp.isHomeDepotActive, translatedText);

    // Prefix for internal navigation if needed (e.g., /home-depot)
    const prefix = isHomeDepotApp.isHomeDepotPrefix || '';

    return (
        <footer className={styles.mainFooterContainer}>

            <GridSystem
                containerBackgroundColor="var(--color-gray-06)"
                containerBorderTop="1px solid var(--color-gray-05)"

            >
                <div className={styles.footerWrapper}>
                    <div className={styles.footerLogoWrapper}>
                        <div className={styles.footerLogoBox}>
                            <LinkedLogo />
                        </div>
                    </div>

                    <section className={styles.container}>
                        {/* Home Appliances (Categories) */}
                        <div className={styles.containerItem}>
                            <PageText type='footerTitle'>{translatedText.homeAppliances}</PageText>
                            {/* <p className={styles.footerTitle}>{translatedText.homeAppliances}</p> */}
                            <div className={styles.footerCol}>
                                {navCategoryLinks.map(({ href, text }) => (
                                    <NavigationLinks
                                        to={`${prefix}${href}`}
                                        key={href}
                                          color="var(--color-gray-02)"
                                    >
                                     {translatedText[text.toLowerCase().replace(/ /g, '')] || text}
                                    </NavigationLinks>
                                    // <LinkComponent
                                    //     key={href}
                                    //     linkText={translatedText[text.toLowerCase().replace(/ /g, '')] || text}
                                    //     href={`${prefix}${href}`}
                                    //     type='footerLinks'
                                    //     trackedLink={true}
                                    // />
                                ))}
                                  <NavigationLinks
                                        to={`/appliances/`}
                                        key={`/appliances/`}
                                          color="var(--color-gray-02)"
                                    >
                                     {translatedText.viewAll}
                                    </NavigationLinks>
                            </div>
                        </div>

                        {/* Step-Up Chart PDFs (dynamic, language/retailer aware) */}
                        <div className={styles.containerItem}>
                            <PageText type='footerTitle'>{translatedText.stepUpChart}</PageText>
                            <div className={styles.footerCol}>
                                {stepUpLinks.map((link, idx) => (
                                    <ExternalNavigationLinks
                                        key={idx}
                                        linkText={link.text}
                                        to={link.link}
                                        color="var(--color-gray-02)"
                                    />

                                ))}
                            </div>
                        </div>

                        {/* Resources */}
                        <div className={styles.containerItem}>
                            <PageText type='footerTitle'>{translatedText.resources}</PageText>
                            <div className={styles.footerCol}>

                                 <NavigationLinks
                                        to={`/resources/definitions`}
                                        key={`/resources/definitions`}
                                        color="var(--color-gray-02)"
                                    >
                                        {translatedText.featureDefinitions}
                                     {/* {translatedText.text}  {translatedText[text.toLowerCase().replace(/ /g, '')] || text} */}
                                    </NavigationLinks>
                                     <NavigationLinks
                                        to={`/resources/warranties`}
                                        key={`/resources/warranties`}
                                        color="var(--color-gray-02)"
                                    >
                                        {translatedText.limitedWarranties}
                                     {/* {translatedText.text}  {translatedText[text.toLowerCase().replace(/ /g, '')] || text} */}
                                    </NavigationLinks>
                               
                            </div>
                            {/* Model transitions PDF (dynamic, language/retailer aware) */}
                            <div className={styles.footerCol}>
                                {transitionsLinks.map((link, idx) => (
                                    <ExternalNavigationLinks
                                        color="var(--color-gray-02)"
                                        key={idx}
                                        linkText={translatedText.modelTransitions || link.text}
                                        to={link.link}
                                    />
                                ))}
                            </div>
                        </div>

                        {/* Exclusive Offers */}
                        <div className={styles.containerItem}>
                            {/* <PageText type='footerTitle'>{translatedText.exclusiveOffers}</PageText> */}
                             <PageText type='footerTitle'>{translatedText.tools}</PageText>
                            <div className={styles.footerCol}>
                                {exclusiveLinks.map(({ href, text }) => (
                                    <NavigationLinks
                                        color="var(--color-gray-02)"
                                        to={`${prefix}${href}`} key={href}>
                                            {translatedText.pL}
                                        {/* {translatedText[text.toLowerCase().replace(/ /g, '')] || text} */}
                                    </NavigationLinks>
                                    // <LinkComponent
                                    //     key={href}
                                    //     linkText={translatedText[text.toLowerCase().replace(/ /g, '')] || text}
                                    //     href={`${prefix}${href}`}
                                    //     type='footerLinks'
                                    //     trackedLink={true}
                                    // />

                                ))}
                            </div>
                        </div>

                        {/* Support & Legal */}
                        <div className={styles.containerItem}>
                            <PageText type='footerTitle'>{translatedText.support}</PageText>
                            <div className={styles.footerCol}>
                                {nativeEmailLinks.map(({ href, text }) => (
                                    <NavigationLinks
                                        key={href}
                                        to={href}
                                        color="var(--color-gray-02)"
                                    >
                                        {translatedText[text.toLowerCase()] || text}
                                    </NavigationLinks>


                                ))}
                            </div>
                            <div className={styles.footerCol}>
                                {legalLinks.map(({ href, text }) => (
                                    <NavigationLinks
                                        key={href}
                                        color="var(--color-gray-02)"
                                        to={`${prefix}${href}`}

                                    >
                                        {translatedText[text.toLowerCase()] || text}
                                    </NavigationLinks>

                                ))}
                            </div>
                            <div className={styles.footerCol}>
                                <div className={styles.languageTranslationWrapper}>
                                    <LanguageSelectionMenu />
                                </div>

                            </div>
                        </div>

                    </section>
                </div>
            </GridSystem>

            <div className={styles.footerRightsBoxWrapper}>
                <GridSystem
                    // containerPaddingTop="1rem"
                    // containerPaddingBottom="1rem"
                    containerBorderTop="1px solid var(--color-gray-04)"
                    // containerBorderBottom="1px solid var(--color-gray-04)"
                    containerBackgroundColor="var(--color-gray-05)"
                >
                    <div className={styles.footerRightsBox}>
                        <PageText type='footerStatement'>{translatedText.allRightsReserved}</PageText>
                    </div>
                </GridSystem>
            </div>
        </footer>
    );
};

export default Footer;
